import styled from "styled-components";
export const StyledSystemStyledNotification = styled.div `
  display: flex;
  align-items: stretch;
  flex-direction: row;
  flex-grow: 1;
`;
function getNotificationColor(notificationType, isTransparent, theme) {
    if (notificationType === "error")
        return isTransparent ? theme.colors.transparentError : theme.colors.error;
    if (notificationType === "warning")
        return isTransparent
            ? theme.colors.transparentWarning
            : theme.colors.warning;
    if (notificationType === "success")
        return isTransparent
            ? theme.colors.transparentSuccess
            : theme.colors.success;
    if (notificationType === "info")
        return isTransparent
            ? theme.colors.transparentPrimaryLight
            : theme.colors.primaryLight;
    if (notificationType === "neutral")
        return isTransparent ? theme.colors.transparent15 : theme.colors.grey15;
    return theme.colors.transparent15;
}
function getTitleColor(notificationType, notificationStyle, theme) {
    if (notificationType === "error")
        return theme.colors.error;
    if (notificationType === "success")
        return theme.colors.success;
    if (notificationType === "warning") {
        if (notificationStyle !== "light")
            return theme.colors.black;
        return theme.colors.error;
    }
    if (notificationType === "neutral" || notificationType === "info")
        return theme.colors.black;
    return theme.colors.black;
}
function getTextColor(notificationType, theme) {
    if (notificationType === "error")
        return theme.colors.error;
    if (notificationType === "success")
        return theme.colors.success;
    if (notificationType === "info" ||
        notificationType === "neutral" ||
        notificationType === "warning")
        return theme.colors.black;
    return theme.colors.black;
}
export const TextWrapper = styled.div `
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 1rem;
  ${({ notificationType, notificationStyle, theme }) => notificationStyle !== "light"
    ? `background: rgba(${getNotificationColor(notificationType, true, theme)},0.1)`
    : `background: ${theme.colors.transparent}`};
  width: ${({ width }) => (width === "full" ? "100%" : "fit-content")};
`;
export const IconWrapper = styled.div `
  ${({ notificationType, notificationStyle, theme }) => notificationStyle !== "light"
    ? `background: ${getNotificationColor(notificationType, false, theme)}; max-width: 2.5rem; padding: 1rem 0.625rem 1rem 0.625rem`
    : `background: ${theme.colors.transparent}; max-width: 1.875rem; padding: 1rem 0 1rem 0.625rem`};
  height: auto;
`;
export const StyledTitle = styled.div `
  ${({ notificationType, notificationStyle, theme }) => `color: ${getTitleColor(notificationType, notificationStyle, theme)}`};
  font-family: ${({ theme }) => theme.fontTokens.defaultFont};
  font-weight: ${({ theme }) => theme.fontWeights.medium};
`;
export const StyledText = styled.div `
  ${({ notificationType, theme }) => `color: ${getTextColor(notificationType, theme)}`};
  font-family: ${({ theme }) => theme.fontTokens.defaultFont};
  font-weight: ${({ theme }) => theme.fontWeights.regular};
`;
